/**
 * Normalise le pathname SPA pour Vercel Speed Insights.
 * Évite « Unknown » et agrège les IDs (INP Desktop par écran).
 */
export function sanitizeSpeedInsightsRoute(pathname = '/') {
  const raw = String(pathname || '/').split('?')[0].split('#')[0].trim();
  const path = raw.startsWith('/') ? raw : `/${raw}`;
  if (path === '/' || path === '') return '/';
  return path
    .replace(/\/\d+(?=\/|$)/g, '/:id')
    .replace(
      /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\/|$)/gi,
      '/:id'
    );
}
